export default __webpack_public_path__ + "src/images/galleries/0/info_en-0d59c3.png";